import React from 'react'
import AppBar from 'components/AppBar'
import { Main } from './styles'

type Props = { visible: boolean; children: React.ReactNode }

const Layout = ({ visible, children }: Props) => {
  if (!visible) return <>{children}</>

  return (
    <>
      <AppBar />
      <Main>{children}</Main>
    </>
  )
}
export default Layout
